import { useDataChange } from 'Simple/Data.js'
export function useOnChange(props) {
  let change = useDataChange({
    context: 'new_phone',
    viewPath: props.viewPath,
  })
  return function onChange(value) {
    change(next => {
      next.appointment_reminders = value
      next.send_next_appointment_reminder = value
    })
  }
}
